import { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from "@mui/material";

function InstallPWAPopUp() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  // Function to detect mobile or tablet
  const isMobileOrTablet = () =>
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  useEffect(() => {
    if (!isMobileOrTablet()) return; // Only trigger on mobile/tablet devices

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPopup(true); // Show popup when install prompt is available
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User installed the app");
        } else {
          console.log("User dismissed the installation");
        }
        setDeferredPrompt(null);
        setShowPopup(false);
      });
    }
  };

  return (
    <Dialog open={showPopup} onClose={() => setShowPopup(false)}>
      <DialogTitle>Install App</DialogTitle>
      <DialogContent>
        <Typography>
          Install this app on your home screen for a better experience.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShowPopup(false)}>Cancel</Button>
        <Button
          onClick={handleInstallClick}
          variant="contained"
          color="primary"
        >
          Install
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default InstallPWAPopUp;
